import * as React from "react";

import { cn } from "../../lib/utils";

const SELECTOR_ACCENTS = Object.freeze({
  neutral: "dataset-selector-neutral",
  coral: "warehouse-tab-coral",
  sage: "warehouse-tab-sage",
  "powder-blue": "warehouse-tab-powder-blue",
  peach: "warehouse-tab-peach",
  teal: "warehouse-tab-teal",
  lavender: "warehouse-tab-lavender",
});

const DatasetSelectorGroup = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    role="group"
    className={cn("flex min-w-0 flex-wrap items-end gap-2", className)}
    {...props}
  />
));
DatasetSelectorGroup.displayName = "DatasetSelectorGroup";

const DatasetSelectorOption = React.forwardRef(({
  selected = false,
  accent = "neutral",
  count,
  indicator = true,
  className,
  children,
  ...props
}, ref) => (
  <button
    ref={ref}
    type="button"
    aria-pressed={selected}
    className={cn(
      "dataset-selector-option warehouse-tab min-w-[172px] shrink-0 px-5 py-3 text-sm font-medium uppercase tracking-normal transition-colors",
      SELECTOR_ACCENTS[accent] || accent,
      selected
        ? "active"
        : "bg-zinc-100 text-zinc-600 hover:text-zinc-900 dark:bg-zinc-900 dark:text-zinc-400 dark:hover:text-zinc-100",
      className
    )}
    {...props}
  >
    <span className="inline-flex min-w-0 items-center justify-center gap-2">
      {indicator ? (
        <span
          aria-hidden="true"
          className="h-2 w-2 shrink-0 rounded-full"
          style={{ backgroundColor: "var(--warehouse-accent)" }}
        />
      ) : null}
      <span className="dataset-selector-label min-w-0 truncate" title={typeof children === "string" ? children : undefined}>{children}</span>
      {typeof count === "number" ? (
        <span className={cn(
          "warehouse-count shrink-0 rounded-full border px-2 py-0.5 text-[10px] tabular-nums",
          !selected && "border-zinc-200 bg-white text-zinc-600 dark:border-zinc-700 dark:bg-zinc-950 dark:text-zinc-300"
        )}>
          {count}
        </span>
      ) : null}
    </span>
  </button>
));
DatasetSelectorOption.displayName = "DatasetSelectorOption";

export { DatasetSelectorGroup, DatasetSelectorOption };
